import { useRef, useState } from "react";
import { Dialog, FormControl, TextInput } from "@primer/react";
import { Button } from "../Button/Button.jsx";
import { parseSharedProfileLink } from "../../lib/sharedProfileLink.js";
import { SharedProfileStatus } from "./SharedProfile.jsx";
import "./OpenSharedLinkDialog.css";

export function OpenSharedLinkDialog({ onClose, returnFocusRef }) {
  const [input, setInput] = useState("");
  const [status, setStatus] = useState(null);
  const [working, setWorking] = useState(false);
  const inputRef = useRef(null);

  async function openLink(event) {
    event?.preventDefault();
    setWorking(true);
    setStatus(null);
    try {
      const parsed = await parseSharedProfileLink(input);
      window.location.hash = `#/shared/${parsed.token}?mode=${parsed.mode}`;
    } catch (error) {
      setStatus({ tone: "danger", text: error.message });
      setWorking(false);
    }
  }

  return <Dialog className="open-shared-link-dialog" title="Open Shared Link" onClose={onClose} initialFocusRef={inputRef} returnFocusRef={returnFocusRef}>
    <form id="open-shared-link-form" onSubmit={openLink}>
      <FormControl required>
        <FormControl.Label>Share or sync link</FormControl.Label>
        <TextInput ref={inputRef} block value={input} onChange={(event) => setInput(event.target.value)} placeholder="Paste a shared link" />
        <FormControl.Caption>Paste a link created by Share a Copy or Server Sync.</FormControl.Caption>
      </FormControl>
    </form>
    <Dialog.Footer className="open-shared-link-footer">
      <div className="open-shared-link-status"><SharedProfileStatus status={status} /></div>
      <div className="open-shared-link-actions">
        <Button tone="secondary" onClick={onClose} disabled={working}>Close</Button>
        <Button type="submit" form="open-shared-link-form" disabled={!input.trim() || working}>{working ? "Opening…" : "Review link"}</Button>
      </div>
    </Dialog.Footer>
  </Dialog>;
}
